import React from "react";
import './WhyChooseUs.css'

const reasons = [
  {
    title: "Experience",
    description:
      "Our team of experts has over a decade of experience in the waterproofing industry, ensuring top-quality workmanship and reliable solutions.",
  },
  {
    title: "Proven Methods",
    description:
      "We use the latest waterproofing techniques and materials, backed by industry-leading warranties, to provide long-lasting protection for your property.",
  },
  {
    title: "Customer Satisfaction",
    description:
      "Hundreds of satisfied customers trust us to safeguard their homes and businesses from water damage, with exceptional service and attention to detail.",
  },
  {
    title: "Commitment to Safety",
    description:
      "Our waterproofing processes are designed with safety in mind, ensuring a clean and secure work environment for our team and your family.",
  },
];

export default function WhyChooseUs() {
  return (
    <section className="why-choose-us">
      <div className="container">
        <h2 className="title">Why Choose Us</h2>
        <div className="grid">
          {reasons.map((reason, index) => (
            <div key={index} className="reason">
              <div className="number">{index + 1}</div>
              <div>
                <h3 className="reason-title">{reason.title}</h3>
                <p className="description">{reason.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
